import type { DistributorLevel } from "@/mocks/users";

export interface Product {
  id: string;
  name: string;
  region: string;
  category: string;
  costPrice: number;
  distributionPrice: number;       // 認購價（基準，普通分銷用）
  normalPrice: number;             // 普通分銷價
  corePrice: number;               // 核心認購價
  dealerPrice: number;             // 特約經銷價（最低）
  suggestedPrice: number;
  stock: number;
  images: string[];
  description: string;
  isHot: boolean;
  isNew: boolean;
  isOnSale: boolean;
  tags: string[];
}

export function getPriceForLevel(product: Product, level: string): number {
  switch (level) {
    case "核心分銷":
      return product.corePrice || product.distributionPrice;
    case "特約經銷":
      return product.dealerPrice || product.distributionPrice;
    case "普通分銷":
      return product.normalPrice || product.distributionPrice;
    default:
      return product.distributionPrice;
  }
}

export const mockProducts: Product[] = [
  {
    id: "p001",
    name: "日本進口保濕精華液 50ml",
    region: "全部商品",
    category: "休閒",
    costPrice: 28,
    distributionPrice: 45,
    normalPrice: 45,
    corePrice: 40,
    dealerPrice: 35,
    suggestedPrice: 128,
    stock: 320,
    images: [
      "https://readdy.ai/api/search-image?query=Japanese%20skincare%20serum%20bottle%20with%20minimalist%20white%20background%2C%20elegant%20glass%20bottle%2C%20premium%20beauty%20product%2C%20soft%20lighting%2C%20clean%20aesthetic%2C%20high%20end%20cosmetics%20photography&width=400&height=400&seq=p001a&orientation=squarish",
    ],
    description: "日本原裝進口，深層補水保濕，適合各種膚質，工廠直供品質保證。",
    isHot: true,
    isNew: false,
    isOnSale: false,
    tags: ["日本進口", "補水保濕", "工廠直供"],
  },
  {
    id: "p002",
    name: "無線藍牙耳機 降噪版",
    region: "全部商品",
    category: "寵物",
    costPrice: 55,
    distributionPrice: 89,
    normalPrice: 89,
    corePrice: 80,
    dealerPrice: 72,
    suggestedPrice: 259,
    stock: 180,
    images: [
      "https://readdy.ai/api/search-image?query=wireless%20bluetooth%20earbuds%20noise%20cancelling%20with%20charging%20case%2C%20white%20background%2C%20modern%20tech%20product%20photography%2C%20clean%20minimal%20style%2C%20premium%20electronics&width=400&height=400&seq=p002a&orientation=squarish",
    ],
    description: "主動降噪技術，30小時超長續航，工廠源頭直供，品質媲美大牌。",
    isHot: true,
    isNew: true,
    isOnSale: false,
    tags: ["降噪", "長續航", "工廠直供"],
  },
  {
    id: "p003",
    name: "北歐風格香薰蠟燭禮盒",
    region: "全部商品",
    category: "家電",
    costPrice: 18,
    distributionPrice: 32,
    normalPrice: 32,
    corePrice: 28,
    dealerPrice: 24,
    suggestedPrice: 89,
    stock: 450,
    images: [
      "https://readdy.ai/api/search-image?query=Nordic%20style%20scented%20candle%20gift%20set%20with%20minimalist%20packaging%2C%20white%20and%20beige%20tones%2C%20cozy%20home%20decor%2C%20clean%20white%20background%2C%20elegant%20lifestyle%20product&width=400&height=400&seq=p003a&orientation=squarish",
    ],
    description: "北歐極簡設計，天然大豆蠟，多種香型可選，送禮自用皆宜。",
    isHot: false,
    isNew: true,
    isOnSale: true,
    tags: ["北歐風", "天然大豆蠟", "禮盒裝"],
  },
  {
    id: "p004",
    name: "韓國潮牌運動短袖 T恤",
    region: "全部商品",
    category: "居家",
    costPrice: 22,
    distributionPrice: 38,
    normalPrice: 38,
    corePrice: 33,
    dealerPrice: 29,
    suggestedPrice: 99,
    stock: 600,
    images: [
      "https://readdy.ai/api/search-image?query=Korean%20streetwear%20oversized%20t-shirt%20flat%20lay%20on%20white%20background%2C%20minimalist%20fashion%20photography%2C%20clean%20studio%20shot%2C%20trendy%20casual%20clothing&width=400&height=400&seq=p004a&orientation=squarish",
    ],
    description: "韓國潮流設計，純棉面料，多色多碼，工廠直供超低認購價。",
    isHot: true,
    isNew: false,
    isOnSale: true,
    tags: ["韓國潮牌", "純棉", "多色可選"],
  },
  {
    id: "p005",
    name: "智能手錶健康監測版",
    region: "全部商品",
    category: "寵物",
    costPrice: 78,
    distributionPrice: 128,
    normalPrice: 128,
    corePrice: 115,
    dealerPrice: 105,
    suggestedPrice: 368,
    stock: 95,
    images: [
      "https://readdy.ai/api/search-image?query=smart%20watch%20health%20monitoring%20on%20white%20background%2C%20modern%20wearable%20technology%2C%20clean%20product%20photography%2C%20sleek%20design%2C%20premium%20smartwatch&width=400&height=400&seq=p005a&orientation=squarish",
    ],
    description: "心率血氧監測，GPS定位，防水設計，工廠源頭好貨。",
    isHot: false,
    isNew: true,
    isOnSale: false,
    tags: ["健康監測", "GPS", "防水"],
  },
  {
    id: "p006",
    name: "多功能廚房料理機",
    region: "全部商品",
    category: "母嬰",
    costPrice: 95,
    distributionPrice: 158,
    normalPrice: 158,
    corePrice: 142,
    dealerPrice: 128,
    suggestedPrice: 428,
    stock: 72,
    images: [
      "https://readdy.ai/api/search-image?query=multifunctional%20kitchen%20food%20processor%20blender%20on%20white%20background%2C%20modern%20home%20appliance%2C%20clean%20product%20photography%2C%20stainless%20steel%20design&width=400&height=400&seq=p006a&orientation=squarish",
    ],
    description: "10合1多功能設計，靜音馬達，易清洗，廚房必備神器。",
    isHot: true,
    isNew: false,
    isOnSale: false,
    tags: ["多功能", "靜音", "易清洗"],
  },
  {
    id: "p007",
    name: "兒童益智積木套裝 200件",
    region: "全部商品",
    category: "玩具童品",
    costPrice: 35,
    distributionPrice: 58,
    normalPrice: 58,
    corePrice: 52,
    dealerPrice: 46,
    suggestedPrice: 158,
    stock: 280,
    images: [
      "https://readdy.ai/api/search-image?query=colorful%20children%20building%20blocks%20educational%20toy%20set%20on%20white%20background%2C%20bright%20colors%2C%20clean%20product%20photography%2C%20kids%20learning%20toy&width=400&height=400&seq=p007a&orientation=squarish",
    ],
    description: "安全無毒材質，200件豐富配件，開發智力，親子互動首選。",
    isHot: false,
    isNew: true,
    isOnSale: true,
    tags: ["益智", "安全無毒", "親子互動"],
  },
  {
    id: "p008",
    name: "便攜式頸部按摩儀",
    region: "全部商品",
    category: "生活",
    costPrice: 42,
    distributionPrice: 72,
    normalPrice: 72,
    corePrice: 65,
    dealerPrice: 58,
    suggestedPrice: 198,
    stock: 165,
    images: [
      "https://readdy.ai/api/search-image?query=portable%20neck%20massager%20device%20on%20white%20background%2C%20modern%20health%20care%20product%2C%20clean%20minimal%20photography%2C%20wireless%20massage%20tool&width=400&height=400&seq=p008a&orientation=squarish",
    ],
    description: "EMS電脈衝技術，多段強度調節，USB充電，辦公室居家兩用。",
    isHot: true,
    isNew: false,
    isOnSale: false,
    tags: ["EMS技術", "USB充電", "辦公居家"],
  },
];

export const mockCategories = [
  {
    id: "cat001",
    name: "休閒",
    count: 520,
    image: "https://readdy.ai/api/search-image?query=leisure%20and%20outdoor%20lifestyle%20products%20collection%20including%20camping%20gear%20sports%20equipment%20and%20travel%20accessories%20arranged%20on%20clean%20light%20background%20with%20warm%20natural%20tones%20and%20premium%20lifestyle%20product%20photography%20soft%20lighting&width=600&height=400&seq=cat001_new&orientation=landscape",
  },
  {
    id: "cat002",
    name: "寵物",
    count: 380,
    image: "https://readdy.ai/api/search-image?query=adorable%20golden%20retriever%20dog%20and%20orange%20tabby%20cat%20sitting%20together%20with%20pet%20toys%20food%20bowls%20and%20accessories%20on%20clean%20soft%20white%20background%20with%20warm%20natural%20lighting%20and%20professional%20pet%20photography&width=600&height=400&seq=cat002_new&orientation=landscape",
  },
  {
    id: "cat003",
    name: "家電",
    count: 640,
    image: "https://readdy.ai/api/search-image?query=modern%20home%20appliances%20collection%20featuring%20stainless%20steel%20refrigerator%20and%20front%20loading%20washing%20machine%20on%20clean%20white%20background%20with%20sleek%20kitchen%20appliance%20product%20photography%20and%20bright%20studio%20lighting%20minimal%20style&width=600&height=400&seq=cat003_new&orientation=landscape",
  },
  {
    id: "cat004",
    name: "居家",
    count: 890,
    image: "https://readdy.ai/api/search-image?query=cozy%20home%20living%20room%20interior%20with%20comfortable%20sofa%20soft%20cushions%20warm%20blanket%20potted%20plants%20and%20minimalist%20Scandinavian%20furniture%20with%20natural%20warm%20lighting%20and%20professional%20home%20decor%20photography&width=600&height=400&seq=cat004_new&orientation=landscape",
  },
  {
    id: "cat005",
    name: "母嬰",
    count: 210,
    image: "https://readdy.ai/api/search-image?query=baby%20and%20maternity%20products%20collection%20with%20cute%20baby%20clothes%20stroller%20milk%20bottles%20and%20soft%20toys%20arranged%20on%20pastel%20background%20with%20gentle%20pink%20and%20white%20tones%20and%20professional%20baby%20product%20photography%20clean%20minimal%20style&width=600&height=400&seq=cat005_new&orientation=landscape",
  },
  {
    id: "cat006",
    name: "生活",
    count: 175,
    image: "https://readdy.ai/api/search-image?query=daily%20lifestyle%20essentials%20collection%20including%20organic%20toiletries%20household%20items%20and%20personal%20care%20products%20on%20clean%20bright%20background%20with%20fresh%20minimal%20aesthetic%20and%20modern%20lifestyle%20product%20photography%20neutral%20tones&width=600&height=400&seq=cat006_new&orientation=landscape",
  },
];

export const mockBanners = [
  {
    id: "b001",
    title: "海外直郵 · 工廠源頭好貨",
    subtitle: "精選跨境爆款，分銷商零庫存輕鬆開店",
    cta: "立即選品",
    image: "https://readdy.ai/api/search-image?query=international%20trade%20warehouse%20with%20packages%20and%20global%20shipping%20concept%2C%20modern%20logistics%20center%2C%20warm%20golden%20lighting%2C%20professional%20commercial%20photography%2C%20wide%20angle%20view&width=1200&height=500&seq=b001&orientation=landscape",
  },
  {
    id: "b002",
    title: "VIP認購區 · 搶先分銷",
    subtitle: "每週更新百款新品，搶佔市場先機",
    cta: "查看新品",
    image: "https://readdy.ai/api/search-image?query=new%20product%20launch%20concept%20with%20various%20consumer%20goods%20arranged%20beautifully%2C%20modern%20e-commerce%20photography%2C%20bright%20clean%20background%2C%20commercial%20product%20display&width=1200&height=500&seq=b002&orientation=landscape",
  },
  {
    id: "b003",
    title: "體驗認購區 · 超低認購價",
    subtitle: "精選百款商品大幅降價，利潤空間更大",
    cta: "搶購優惠",
    image: "https://readdy.ai/api/search-image?query=sale%20promotion%20concept%20with%20various%20products%20and%20discount%20tags%2C%20vibrant%20commercial%20photography%2C%20warm%20golden%20tones%2C%20e-commerce%20promotional%20banner%20style&width=1200&height=500&seq=b003&orientation=landscape",
  },
];
